import React from 'react';
import { Input } from '@tracekit/core';
import { Search, X } from 'lucide-react';
import { formatIndustryNewsSearchResultsLabel } from '../utils/industryNewsSearch';

interface IndustryNewsSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  resultCount?: number;
  placeholder?: string;
  className?: string;
}

export function IndustryNewsSearchBar({
  value,
  onChange,
  onClear,
  resultCount,
  placeholder = 'Search articles by title or description…',
  className = 'mb-3',
}: IndustryNewsSearchBarProps) {
  const trimmed = value.trim();
  const resultsLabel =
    trimmed && resultCount !== undefined
      ? formatIndustryNewsSearchResultsLabel(resultCount, trimmed)
      : '';

  return (
    <div className={`space-y-2 ${className}`.trim()}>
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label="Search industry news articles"
        leftIcon={<Search className="h-4 w-4" />}
        rightIcon={
          trimmed ? (
            <button
              type="button"
              onClick={onClear}
              className="rounded p-0.5 text-theme-text-secondary hover:text-theme-text"
              aria-label="Clear search"
            >
              <X className="h-4 w-4" />
            </button>
          ) : undefined
        }
      />
      {resultsLabel && (
        <p className="text-xs text-gray-500 dark:text-gray-400">{resultsLabel}</p>
      )}
    </div>
  );
}
